import { Injectable } from "@angular/core";
import { ApplicationUser } from "../../pb-screen/models/application.user.interface";
import { ApplicationUserService } from "../../pb-screen/services/application.user.service";

import { ButtonVisibility } from "../models/buttons-visibility";
import { Observable } from "rxjs/Observable";
import { select } from "@angular-redux/store";

@Injectable()
export class ButtonVisibilityService {
    
    @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
    applicationUser: ApplicationUser;
   
    constructor(
        private readonly applicationUserService: ApplicationUserService ){   

        this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
                if (applicationUser) {
                    this.applicationUser = applicationUser;
                }
            } );

        }
     public isButtonHidden(buttonId: string): boolean {   
       let buttonVisibility = (this.applicationUser.buttonsVisibility.filter((s:ButtonVisibility)=> s.buttonId === buttonId && s.isVisible === false)); 
       return buttonVisibility.length > 0  ; 
        
    }
}